import React from 'react'
import { ClipPath, Defs, G, Path, Rect } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const JyvIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <G clipPath='url(#clip0_10859_99564)'>
                <Path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M8 12H24V24H0V12H3V8H8V12ZM5.67 14V19.463C5.67 19.857 5.577 20.161 5.393 20.374C5.209 20.587 4.961 20.694 4.65 20.694C4.3 20.694 4.043 20.602 3.88 20.417C3.718 20.233 3.637 19.947 3.637 19.561H2C2 20.338 2.233 20.939 2.7 21.363C3.165 21.788 3.816 22 4.65 22C5.16 22 5.617 21.895 6.022 21.686C6.426 21.476 6.74 21.179 6.962 20.794C7.184 20.409 7.295 19.966 7.295 19.464V14H5.67ZM11.41 17.556L9.777 14H7.995L10.585 19.03V21.892H12.238V19.03L14.83 14H13.052L11.41 17.556ZM18.564 19.935L16.786 14H14.98L17.717 21.892H19.414L22.163 14H20.353L18.564 19.935ZM4 0H7V2H4V0ZM0 3H11L9 7H2L0 3ZM16.845 9L18.028 5.2H15.422L14.705 6.155H14L14.466 4.495L14 2.844H14.705L15.422 3.776H18.028L16.845 0H17.777L20.155 3.777H22.761C22.958 3.777 23.125 3.846 23.261 3.982C23.3283 4.04884 23.3812 4.12874 23.4165 4.21679C23.4517 4.30485 23.4686 4.39919 23.466 4.494C23.4679 4.5871 23.451 4.67963 23.4162 4.76603C23.3815 4.85243 23.3296 4.93091 23.2638 4.99676C23.1979 5.0626 23.1194 5.11446 23.033 5.14922C22.9466 5.18397 22.8541 5.20091 22.761 5.199H20.155L17.777 9H16.845Z'
                    fill='currentColor'
                />
            </G>
            <Defs>
                <ClipPath id='clip0_10859_99564'>
                    <Rect fill='currentColor' />
                </ClipPath>
            </Defs>
        </>
    ),
})

JyvIcon.displayName = 'JyvIcon'
